module.exports = __webpack_public_path__ + "static/media/volunteer.9a0b8679.png";